module.exports = __webpack_public_path__ + "72efca5db75fe9d4c608681ec8fef8cd.fbx";